import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { PRODUCT_DOMAIN_URL } from "../../utils/Constants";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Copyright = (props: any) => {
  const { t } = useTranslation();
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {"Copyright © "}
      <Link color="inherit" href={PRODUCT_DOMAIN_URL}>
        {t("product.name")}
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};
